import { Box, Typography } from '@mui/material';
import type { ReactElement, ReactNode } from 'react';

import { InfoTooltip } from '../../components/InfoTooltip';

interface SettingLabelProps {
  label: string;
  tooltip: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

/**
 * A setting label paired with an info icon that reveals an explanatory tooltip.
 * Used across the admin settings cards so every toggle/field documents what it does.
 */
export function SettingLabel({ label, tooltip, side = 'right' }: SettingLabelProps): ReactElement {
  return (
    <Box className="vtwo:flex vtwo:items-center vtwo:gap-1.5">
      <Typography className="vtwo:text-typography-primary">{label}</Typography>
      <InfoTooltip label={label} tooltip={tooltip} side={side} />
    </Box>
  );
}
